import { createSlice, AnyAction } from "@reduxjs/toolkit";
import type { BannerAllViewState } from "../types";

const initialState: BannerAllViewState = {
  tabSelected: "liveScheduled",
  rowsTileToggleValue: "rows",

  showResetButton: false,

  expiredBannersFetched: false,

  filter: {
    queryKeys: [
      "banner_id",
      "script_value",
      "script_type",
      "position_name",
      "status",
      "title",
    ],
    filterSelect: {
      position_name: "",
      platform_id: null,
    },
    searchValue: "",
    idKey: "banner_id",
  },
  sortBy: {
    sortKey: "banner_id",
    reverse: true,
  },
};

const bannerAllViewSlice = createSlice({
  name: "bannerAllView",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("SEARCH_TABLE_VALUES", (state, action: AnyAction) => {
        state.filter.searchValue = action.searchValue;
        state.showResetButton =
          state.showResetButton || action.searchValue !== "";
      })
      .addCase("CLICK_TAB", (state, action: AnyAction) => {
        state.tabSelected = action.status;
        state.filter = initialState.filter;
        state.showResetButton = false;
      })
      .addCase("SET_TABLE_VIEW", (state, action: AnyAction) => {
        state.rowsTileToggleValue = action.view;
      })
      .addCase("SET_FILTER_PLATFORM", (state, action: AnyAction) => {
        state.showResetButton = true;
        state.filter.filterSelect.platform_id = action.platformId;
      })
      .addCase("SET_FILTER_POSITION", (state, action: AnyAction) => {
        state.showResetButton = true;
        state.filter.filterSelect.position_name = action.selectedPosition;
      })
      .addCase("SET_FILTER_DATE", (state, action: AnyAction) => {
        state.showResetButton = true;
        if (action.timeSelected === "start") {
          (state.filter as any).startDateTime = action.dateTime;
        } else {
          (state.filter as any).stopDateTime = action.dateTime;
        }
      })
      .addCase("RESET_FILTER_ALL", (state) => {
        state.filter = initialState.filter;
        state.showResetButton = false;
      })
      .addCase("SET_SORT_PARAM", (state, action: AnyAction) => {
        state.sortBy.sortKey = action.sortKey;
        state.sortBy.reverse = action.reverse;
      });
  },
});

export const selectBannerAllView = (state: {
  bannerAllView: BannerAllViewState;
}): BannerAllViewState => state.bannerAllView;

export default bannerAllViewSlice.reducer;
